import React from 'react';
import CameraViewIcon from './CameraViewIcon';

export const IconFront = () => (
  <CameraViewIcon width="41.627" height="31.414" viewBox="0 0 41.627 31.414">
    <g transform="translate(-271.793 -951.793)">
      <path
        d="M12.89.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H12.89a.5.5,0,0,1,.5.5A.5.5,0,0,1,12.89.5Z"
        transform="translate(286.177 980.786)"
        fill="currentColor"
      />
      <path
        d="M36.412.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H36.412a.5.5,0,0,1,.5.5A.5.5,0,0,1,36.412.5Z"
        transform="translate(274.41 954.387)"
        fill="currentColor"
      />
      <path
        d="M0,2.417a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V1.917A.5.5,0,0,1,0,2.417Z"
        transform="translate(299.067 979.867)"
        fill="currentColor"
      />
      <path
        d="M1.125.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.125a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.125.5Z"
        transform="translate(299.066 981.783)"
        fill="currentColor"
      />
      <path
        d="M0,2.417a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V1.917A.5.5,0,0,1,0,2.417Z"
        transform="translate(300.192 979.866)"
        fill="currentColor"
      />
      <path
        d="M0,2.417a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V1.917A.5.5,0,0,1,0,2.417Z"
        transform="translate(286.177 979.867)"
        fill="currentColor"
      />
      <path
        d="M1.125.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.125a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.125.5Z"
        transform="translate(285.052 981.783)"
        fill="currentColor"
      />
      <path
        d="M0,2.417a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V1.917A.5.5,0,0,1,0,2.417Z"
        transform="translate(285.052 979.866)"
        fill="currentColor"
      />
      <path
        d="M0,1.445a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.945A.5.5,0,0,1,0,1.445Z"
        transform="translate(304.195 981.762)"
        fill="currentColor"
      />
      <path
        d="M1.713.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.713a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.713.5Z"
        transform="translate(304.196 982.707)"
        fill="currentColor"
      />
      <path
        d="M0,1.445a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.945A.5.5,0,0,1,0,1.445Z"
        transform="translate(305.908 981.762)"
        fill="currentColor"
      />
      <path
        d="M52.026,39.885a.5.5,0,0,1-.406-.792.829.829,0,0,1,.671-.344.611.611,0,0,1-.266,1.136Z"
        transform="translate(250.448 935.741)"
        fill="currentColor"
      />
      <path
        d="M51.85,40.285h-.018a.5.5,0,0,1-.482-.517,1.017,1.017,0,0,1,.2-.579.5.5,0,1,1,.81.587l-.008.012s0,.005,0,.015A.5.5,0,0,1,51.85,40.285Z"
        transform="translate(250.521 935.644)"
        fill="currentColor"
      />
      <path
        d="M0,6.833H-.016A.5.5,0,0,1-.5,6.317L-.291-.017A.5.5,0,0,1,.226-.5.5.5,0,0,1,.709.017L.5,6.35A.5.5,0,0,1,0,6.833Z"
        transform="translate(302.161 975.429)"
        fill="currentColor"
      />
      <path
        d="M5.276.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H5.276a.5.5,0,0,1,.5.5A.5.5,0,0,1,5.276.5Z"
        transform="translate(302.161 981.762)"
        fill="currentColor"
      />
      <path
        d="M0,1.445a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.945A.5.5,0,0,1,0,1.445Z"
        transform="translate(281.258 981.762)"
        fill="currentColor"
      />
      <path
        d="M1.713.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.713a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.713.5Z"
        transform="translate(279.545 982.707)"
        fill="currentColor"
      />
      <path
        d="M0,1.445a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.945A.5.5,0,0,1,0,1.445Z"
        transform="translate(279.545 981.762)"
        fill="currentColor"
      />
      <path
        d="M18.557,39.885a.5.5,0,0,1-.351-.143.5.5,0,0,1,.085-.993.829.829,0,0,1,.671.344.5.5,0,0,1-.406.792Z"
        transform="translate(264.423 935.741)"
        fill="currentColor"
      />
      <path
        d="M18.846,40.285a.5.5,0,0,1-.5-.482.1.1,0,0,0,0-.016l-.007-.011a.5.5,0,0,1,.81-.587,1.017,1.017,0,0,1,.2.579.5.5,0,0,1-.482.517Z"
        transform="translate(264.236 935.644)"
        fill="currentColor"
      />
      <path
        d="M.209,6.833a.5.5,0,0,1-.5-.483L-.5.017A.5.5,0,0,1-.017-.5.5.5,0,0,1,.5-.017l.21,6.333a.5.5,0,0,1-.483.516Z"
        transform="translate(283.082 975.429)"
        fill="currentColor"
      />
      <path
        d="M5.276.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H5.276a.5.5,0,0,1,.5.5A.5.5,0,0,1,5.276.5Z"
        transform="translate(278.016 981.762)"
        fill="currentColor"
      />
      <path
        d="M0,2.942a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.442A.5.5,0,0,1,0,2.942Z"
        transform="translate(299.067 974.396)"
        fill="currentColor"
      />
      <path
        d="M0,2.942a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.442A.5.5,0,0,1,0,2.942Z"
        transform="translate(300.192 974.396)"
        fill="currentColor"
      />
      <path
        d="M0,2.942a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.442A.5.5,0,0,1,0,2.942Z"
        transform="translate(285.052 974.396)"
        fill="currentColor"
      />
      <path
        d="M0,2.942a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.442A.5.5,0,0,1,0,2.942Z"
        transform="translate(286.177 974.396)"
        fill="currentColor"
      />
      <path
        d="M18.994.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H18.994a.5.5,0,0,1,.5.5A.5.5,0,0,1,18.994.5Z"
        transform="translate(283.229 979.866)"
        fill="currentColor"
      />
      <path
        d="M19.195.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H19.195a.5.5,0,0,1,.5.5A.5.5,0,0,1,19.195.5Z"
        transform="translate(283.129 976.838)"
        fill="currentColor"
      />
      <path
        d="M57.176,46.522a.5.5,0,0,1-.494-.43,28.809,28.809,0,0,0-.711-3.761,19.124,19.124,0,0,0-.6-1.822,5.869,5.869,0,0,0-.313-.712l-.008-.014c-.376-.033-1.955-.033-2.576-.033a.5.5,0,0,1,0-1c2.759,0,2.818.027,3.013.118a.943.943,0,0,1,.44.434,6.63,6.63,0,0,1,.376.847,20.123,20.123,0,0,1,.627,1.918,29.68,29.68,0,0,1,.737,3.884.5.5,0,0,1-.5.57Z"
        transform="translate(250.26 935.74)"
        fill="currentColor"
      />
      <path
        d="M10.272,46.522a.5.5,0,0,1-.5-.57,29.683,29.683,0,0,1,.737-3.884,20.131,20.131,0,0,1,.627-1.918,6.635,6.635,0,0,1,.375-.845.946.946,0,0,1,.441-.437c.2-.091.254-.118,3.013-.118a.5.5,0,1,1,0,1c-.62,0-2.2,0-2.576.033l-.009.016a5.88,5.88,0,0,0-.311.71,19.124,19.124,0,0,0-.6,1.823,28.811,28.811,0,0,0-.711,3.761A.5.5,0,0,1,10.272,46.522Z"
        transform="translate(267.745 935.74)"
        fill="currentColor"
      />
      <path
        d="M0,22.6a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V22.1A.5.5,0,0,1,0,22.6Z"
        transform="translate(274.41 952.293)"
        fill="currentColor"
      />
      <path
        d="M0,22.6a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V22.1A.5.5,0,0,1,0,22.6Z"
        transform="translate(310.822 952.293)"
        fill="currentColor"
      />
      <path
        d="M0,22.6a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V22.1A.5.5,0,0,1,0,22.6Z"
        transform="translate(312.919 952.293)"
        fill="currentColor"
      />
      <path
        d="M0,22.6a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V22.1A.5.5,0,0,1,0,22.6Z"
        transform="translate(272.293 952.293)"
        fill="currentColor"
      />
      <path
        d="M40.626.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H40.626a.5.5,0,0,1,.5.5A.5.5,0,0,1,40.626.5Z"
        transform="translate(272.293 952.293)"
        fill="currentColor"
      />
      <path
        d="M40.626.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H40.626a.5.5,0,0,1,.5.5A.5.5,0,0,1,40.626.5Z"
        transform="translate(272.293 974.396)"
        fill="currentColor"
      />
    </g>
  </CameraViewIcon>
);

export default IconFront;
